import type { FeedbackType } from '@/modules/feedback/use-cases'
import { ToggleGroup, ToggleGroupItem } from '@/shared/ui/primitives'
import { FEEDBACK_TYPE_CONFIG } from './feedback-type-config'

type FeedbackTypeSelectorProps = {
  value: FeedbackType
  onChange: (type: FeedbackType) => void
}

export function FeedbackTypeSelector({ value, onChange }: FeedbackTypeSelectorProps) {
  return (
    <ToggleGroup
      type="single"
      variant="card"
      value={value}
      onValueChange={(v) => {
        if (v) onChange(v as FeedbackType)
      }}
      className="flex flex-wrap gap-2"
    >
      {FEEDBACK_TYPE_CONFIG.map((item) => (
        <ToggleGroupItem
          key={item.value}
          value={item.value}
          className={item.activeClass}
        >
          <span className="flex items-center gap-1.5 text-sm">
            <item.Icon className="size-4" />
            <span>{item.label}</span>
          </span>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
